import React, { useContext, useState } from 'react';
import '../styles/Agreement.css';
import Eula from './Eula';
import TAC from './TAC';
import { Accordion, AccordionTab } from 'primereact/accordion';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { toast } from 'react-toastify';
import {ReactComponent as Spinner} from '../assets/spinner.svg';
import { context } from '../App';

export default function Agreement({setShowAgreement, resetStates, agreeEnabled, setAgreeEnabled, contactId, isAgreementContactId}) {
    console.log(isAgreementContactId)
    const {token, payload} = useContext(context);
    const [isLoading, setIsLoading] = useState(false);

    function sendEmail(){
        setIsLoading(true);

        fetch("https://api.proinsight.com/send_agreements", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization" : token
            },
            body: JSON.stringify({"email": payload.email.email})
        })
        .then(resp => {
            if(resp.ok){
                toast.success("Agreement sent to email");
                setIsLoading(false);
                setAgreeEnabled(true);
            }
            else{
                toast.error("Something went wrong");
                setIsLoading(false);
            }
        })
        .catch(err => {
            toast.error("Something went wrong");
            setIsLoading(false);
        })
    }

    function sendContactId(){
        setIsLoading(true);

        fetch("https://api.proinsight.com/send_agreements_using_contactId", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization" : token
            },
            body: JSON.stringify({"contactId": contactId})
        })
        .then(resp => {
            if(resp.ok){
                toast.success("Agreement sent to email");
                setIsLoading(false);
                setAgreeEnabled(true);
            }
            else{
                toast.error("Something went wrong");
                setIsLoading(false);
            }
        })
        .catch(err => {
            toast.error("Something went wrong");
            setIsLoading(false);
        })
    }

    return (
        <section className="agreement">
            <div className="agreement-inner">
                <div className="eula">
                    <Accordion>
                        <AccordionTab headerTemplate={
                            <div className='headerTemplate'>
                                <span>Terms & Conditions</span>
                                <button className='decline' onClick={isAgreementContactId ? sendContactId : sendEmail}>
                                    {
                                        isLoading
                                        ?
                                            <Spinner stroke='#1b365d'/>
                                        :
                                            "Send via Email"
                                    }
                                </button>
                            </div>
                        }>
                            <Eula />
                        </AccordionTab>

                        <AccordionTab header="End User License Agreement (EULA)">
                            <TAC />
                        </AccordionTab>
                    </Accordion>
                </div>

                <div>
                    <div className="checkbox-container">
                        <input type="checkbox" checked={agreeEnabled} id='checkbox' onChange={()=>setAgreeEnabled(!agreeEnabled)}/>
                        <label htmlFor="checkbox">I have read and agree with above terms and conditions.</label>
                    </div>

                    <div className="agreement-buttons">
                        <button className="decline" onClick={()=>{
                            resetStates();
                        }}>I Decline</button>
                        <button className="accept" disabled={!agreeEnabled} onClick={()=>setShowAgreement(false)}>I Accept</button>
                    </div>
                </div>
            </div>
        </section>
    )
}